import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { signOutUser, checkUser, refreshToken } from './actions/auth';
import * as serviceWorker from './serviceWorker';
import axios from 'axios';


import createStore from './store';

// Create a store and get back itself and its history object
const { store, history } = createStore();

store.dispatch(checkUser())



axios.interceptors.response.use(
  response => response,
  async (error) => {
    if (error.response.status !== 401) {
      return Promise.reject(error)
    }

    const originalRequest = error.config;

    if (originalRequest._retry) {
      store.dispatch(signOutUser(error));
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const newAccess = await refreshToken();

      originalRequest.headers['Authorization'] = `Bearer ${newAccess}`;

      return axios(originalRequest);
    } catch (err) {
      console.log('Refresh expired or failed');
      store.dispatch(signOutUser(error));

      return Promise.reject(err);
    }
  })


ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
